import script from "./SocietalChangeView.vue?vue&type=script&setup=true&lang=js"
export * from "./SocietalChangeView.vue?vue&type=script&setup=true&lang=js"

import "./SocietalChangeView.vue?vue&type=style&index=0&id=47c28fd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47c28fd0"]])

export default __exports__